/**
 *
 */
const style = (t) => {
    const { colors, typography } = t['foundations-library']
    return {
        alert: {
            ...typography.subtitle2,
            borderRadius: '6px',
            padding: '8px 30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
            flexShrink: 0,
            minHeight: '50px',
            '& .alert--content': {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                '& .alert--content-inner': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                }
            },
            '&.alert--no-border-radius': {
                borderRadius: '0 !important'
            },
            '&.alert--error': {
                color: 'white',
                background: colors.destructive[400]
            },
            '&.alert--success': {
                color: colors.primary[500],
                background: colors.primary[50]
            },
            '& .alert--message': {
                display: 'inline-block',
                verticalAlign: 'middle'
            },
            '& .alert--icon': {
                marginRight: 0
            },
            '& .alert--close-icon': {
                marginLeft: 'auto',
                cursor: 'pointer'
            },
            '& .alert--button': {
                marginLeft: 0
            }
        }
    }
}
export default style
